// @flow
import { type UserInputValidationError, type UserInputValidatorArgs, VALID} from '@tectonics/prs/validation';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
  incomingPayment,
}: UserInputValidatorArgs): ?UserInputValidationError {
  return VALID;
}
